module.exports = __webpack_public_path__ + "img/icon_Wi-Fi.f4c6fd50.svg";